import { render, staticRenderFns } from "./DepositSlipTemplate.vue?vue&type=template&id=7cab6bb2&scoped=true"
import script from "./DepositSlipTemplate.vue?vue&type=script&lang=js"
export * from "./DepositSlipTemplate.vue?vue&type=script&lang=js"
import style0 from "./DepositSlipTemplate.vue?vue&type=style&index=0&id=7cab6bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cab6bb2",
  null
  
)

export default component.exports